<template>
  <div class="login-wrapper">
    <div class="login-title">
      <img src="../logo.png" class="logo-icon" />
    </div>
    <div class="btn" @click="downLoadClick">下载APP</div>
    <div class="mask" v-show="show">
      <img src="./tips.png" alt="" class="tips" />
      <img src="./click.png" alt="" class="click" />
    </div>
  </div>
</template>
<script>
import { ERROR_OK } from "../../request/http";
import { getVersion } from "../../request/api/common";
import { Toast } from "vant";
export default {
  data() {
    return {
      show: false
    };
  },
  components: {
    [Toast.name]: Toast
  },
  methods: {
    downLoadClick() {
      window.location.href =
        "https://a.app.qq.com/o/simple.jsp?pkgname=com.edu.jimu";
      // let isWeiXin = this.isWeiXin();
      // if (isWeiXin) {
      //   this.show = true;
      // } else {
      //   this.getApp();
      // }
    },
    getApp() {
      // let isAndroid =
      //   navigator.userAgent.indexOf("Android") > -1 ||
      //   navigator.userAgent.indexOf("Adr") > -1;
      let isLinux = /Linux/i.test(navigator.platform);
      // if (!isAndroid && !isLinux) {
      //   Toast.fail({
      //     type: "fail",
      //     message: "ios版本未上架",
      //     duration: 1000
      //   });
      //   return;
      // }
      getVersion({
        osType: isLinux ? 2 : 1,
        version: 0
      }).then(res => {
        console.log(res, "fffff");
        if (res.code === ERROR_OK) {
          window.location.href = res.data.updateUrl;
        }
      });
    },
    isWeiXin() {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true; // 是微信端
      } else {
        return false;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.login-wrapper {
  position: absolute;
  top: 0px;
  left: 0;
  bottom: 0;
  right: 0;
  background: #fff;
  .login-title {
    padding-top: 376px;
    .logo-icon {
      display: block;
      width: 182px;
      height: 206px;
      margin: 0 auto;
    }
  }
  .btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 610px;
    height: 90px;
    margin: 88px auto 0;
    background: #ff933b;
    border-radius: 45px;
    font-size: 34px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
  }
  .mask {
    position: absolute;
    top: 0px;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
    .tips {
      width: 560px;
      height: 48px;
      margin: 134px auto 0;
    }
    .click {
      position: absolute;
      top: 10px;
      right: 56px;
      width: 71px;
      height: 99px;
    }
  }
}
</style>
